export const REGISTER_MODULE = 'register'

// Action
export const REGISTER = 'register'
export const SOCIAL_REGISTER = 'socialRegister'
export const GET_PROVIDER_INFO = 'getProviderInfo'
export const GET_USER_PROVIDERS = 'getUserProviders'
export const SOCIAL_EMAIL_BINDING = 'socialEmailBinding'
export const EMAIL_PROVIDER_BINDING = 'emailProviderBinding'
export const CLEAR_REGISTER_STATE = 'clearRegisterState'

// Mutation
export const SET_EMAIL_ERROR = 'setEmailError'
export const RESET_EMAIL_ERROR = 'resetEmailError'
export const SET_PROVIDER = 'setProvider'
export const SET_DISPLAY_NAME = 'setDisplayName'
export const SET_PROFILE_PIC_URL = 'setProfilePicURL'
export const SET_PROVIDERS = 'setProviders'
export const SET_USER_EMAIL = 'setUserEmail'

// Getters
export const EMAIL_SERVER_ERROR = 'getEmailError'
export const PROVIDER = 'getProvider'
export const USER_PROVIDERS = 'getUserProviders'
export const DISPLAY_NAME = 'getDisplayName'
export const USER_EMAIL = 'getUserEmail'
export const PROFILE_PICTURE_URL = 'getProfilePictureURL'
export const EMAIL_PROVIDER = 'getEmailProvider'
export const APPLE_PROVIDER = 'getAppleProvider'
export const LINE_PROVIDER = 'getLineProvider'
export const FACEBOOK_PROVIDER = 'getFacebookProvider'
export const HAS_PASSWORD = 'hasPassword'

export const UNSENTABLE_EMAIL_ERROR = 'Unsentable Email'
export const PROVIDER_EXIST_ERROR = 'Provider Exist'
